export const meses = () => [
    { id: 0, text: 'Enero' },
    { id: 1, text: 'Febrero' },
    { id: 2, text: 'Marzo' },
    { id: 3, text: 'Abril' },
    { id: 4, text: 'Mayo' },
    { id: 5, text: 'Junio' },
    { id: 6, text: 'Julio' },
    { id: 7, text: 'Agosto' },
    { id: 8, text: 'Septiembre' },
    { id: 9, text: 'Octubre' },
    { id: 10, text: 'Noviembre' },
    { id: 11, text: 'Diciembre' },
  ];

  export const headers_punis = () => [
    { text: 'codigo', value: 'codigo' },
    { text: 'programa Nombre', value: 'programaNombre' },
    { text: 'sede Universidad', value: 'sedeUniversidad.nombre' },
    { text: 'estado', value: 'estado' },
  ];

  export const headers_punis2 = () => [
    { text: 'codigo', value: 'codigo' },
    { text: '', value: 'sede' },
    { text: 'Programa Universidad', value: 'programaNombre' },
    { text: 'sede Universidad', value: 'sedeUniversidad' },
    { text: 'estado', value: 'estado' },
    { text: '', value: 'opt' },
  ];
  export const headers_punis3 = () => [
    { text: 'codigo prog. u.', value: 'codigo' },
    { text: 'programa universidad', value: 'programaNombre' },
    { text: 'sede Universidad', value: 'sedeUniversidad' },
    { text: 'estado', value: 'estado' },
    { text: '', value: 'opt' },
  ];
  